import React from 'react';
import { ExtendedTheme, Heading } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/core';
import { ListItem, IdAndName} from '../../shared/types';
import { getDeskLink} from '../../utils/link.utils';
import { sortArray } from '../../utils/sorting.utils';
import LinkList, { ListItemOrientation, ListItemType } from './LinkList';


const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	recentArticles: {
		marginBottom: theme.spacing(2)
	}
}));

export interface DesksSectionProps {
	deskList?: IdAndName[];
}

export const DesksSection: React.FC<DesksSectionProps> = (props) => {
	const classes = useStyles();

	if (!props.deskList?.length) return null;

	const dataToShow: ListItem[] = sortArray(props.deskList, 'name')
		.map(art => ({
			id: art._id,
			name: art.name,
			url: getDeskLink(art._id)
		}));

	return (
		<div>
			<Heading
				className={classes.recentArticles}
				styleName="title1"
				xs="small"
				md="medium"
				xl="large"
			>
				Desks
			</Heading>
			<div id={'desks-section'}>
				<LinkList
					disableSort
					items={dataToShow}
					orientation={ListItemOrientation.Vertical}
					displayType={ListItemType.Link}
					isSpacedVerticalLinks={true}
				/>
			</div>
		</div>
	);
};

export default DesksSection;

